import { useEffect, useRef, useState } from "react";
import { ProgramType } from "data/programData";
import useFetch from "./useFetch";
import useGetBlankThoughtRecordData from "./useGetBlankThoughtRecordData";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";
import { SentimentType } from "api/thoughtRecordApi";

export default function useGetThoughtRecordData({
  trk,
  isFirst,
  sentiment,
  enabled = true,
}: {
  trk?: string;
  isFirst?: boolean;
  sentiment?: SentimentType;
  enabled?: boolean;
}) {
  const [data, setData] = useState<ProgramType>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const blankThoughtRecordData = useGetBlankThoughtRecordData({
    trk: trk,
    isFirst: isFirst,
    sentiment: sentiment,
    enabled: enabled,
  });

  const [fetchedData, getData] = useFetch({
    url: "/thought-record/data/load",
    params: { trk: trk },
  });

  useEffect(() => {
    if (enabled && trk && isFirst !== undefined) {
      setIsFetching(true); // 로딩 시작 시점 명확히 설정
      getData();
    }
  }, [trk, enabled, isFirst]);

  // 이미 넣은 응답 — 기록을 바꾸면 빈 양식이 먼저 바뀌는데, 그때 이전 기록의 응답을 새 기록 내용으로 다시 내보내지 않는다
  const appliedRef = useRef<typeof fetchedData>();

  useEffect(() => {
    if (
      fetchedData &&
      blankThoughtRecordData &&
      fetchedData !== appliedRef.current
    ) {
      appliedRef.current = fetchedData;
      const totalData = (fetchedData?.result || {}).data;
      if (totalData && totalData.content.length > 0) {
        setData(setDataWithEditorKeyAndTranslationVersion(totalData));
      } else {
        setData(blankThoughtRecordData);
      }
      setIsFetching(false); // 로딩 완료 시점 명확히 설정
    }
  }, [fetchedData, blankThoughtRecordData]);

  useEffect(() => {
    if (data) {
      setIsFetching(false);
    }
  }, [data]);

  return { data, refetch: getData, isFetching };
}
